import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/good/example/list',
        method: 'get',
        params:data
    })
}
export function newsDetail(data) {
    return request({
        url: "/good/example/detail",
        method: "get",
        params: data
    });
}

export function contactUs(data) {
    return request({
        url: "/home/contact/us",
        method: "post",
        params: data
    });
}